import Container from "@components/Atomic/Container/Container";
import { StyledButtonLink } from "@components/Styled/Button";
import { StyledContainer } from "@components/Styled/Container";
import { StyledH5 } from "@components/Styled/Text";
import { clsx } from "clsx";
import React from "react";
import SwiperCore, { Autoplay } from "swiper";
import { SwiperSlide } from "swiper/react";
import { withTestimonialSlider } from "./withTestimonialSlider";

import { SanityImage2, IconVintageArrow } from "@bared/ui";

import Swiper from "../../Swiper/Swiper";

SwiperCore.use([Autoplay]);

const Wrapper = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, "relative pb-maxi sm:px-mega md:px-tera")}
  />
);
const SlideWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "px-midi py-maxi text-center md:px-mega md:py-tera",
    )}
  />
);
const ContentWrapper = (props: any) => (
  <span
    {...props}
    className={clsx(
      props.className,
      "block pt-mini font-display text-body leading-caption md:px-mega md:text-h3",
    )}
  />
);
const AuthorWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "pt-mini md:text-center")} />
);
const ImageWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "inline-block w-giga overflow-hidden rounded-full align-top",
    )}
  />
);
const AuthorInfo = (props: any) => (
  <div {...props} className={clsx(props.className, "ml-mini inline-block")} />
);
const AuthorName = (props: any) => (
  <StyledH5
    {...props}
    className={clsx(props.className, "text-left uppercase")}
  />
);
const LearnMore = (props: any) => (
  <div {...props} className={clsx(props.className, "underline")} />
);
const Button = (props: any) => (
  <StyledButtonLink
    {...props}
    className={clsx(
      props.className,
      "flex items-start justify-between text-left",
    )}
  />
);
const StyledArrow = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "absolute top-1/2 hidden cursor-pointer text-primary hover:opacity-70 md:block",
      props.direction === "prev" ? "left-0 rotate-180 transform" : "right-0",
    )}
  />
);

const SliderArrow = ({ id, direction }: { id: string; direction: string }) => (
  <StyledArrow id={id} direction={direction}>
    <IconVintageArrow direction="right" className="w-[24px]" />
  </StyledArrow>
);

const TestimonialSlider = withTestimonialSlider(
  ({ sectionLinks, sliderAutoDelay, styles }) => {
    return (
      <Container
        styles={styles}
        data-component-type="section-testimonial-slider"
      >
        <Wrapper width="xl">
          <SliderArrow id="prev" direction="prev" />
          <SliderArrow id="next" direction="next" />
          <Swiper
            autoplay={sliderAutoDelay}
            loop={true}
            navigation={{
              prevEl: "#prev",
              nextEl: "#next",
            }}
            observeParents={true}
            observer={true}
            pagination={{ clickable: true }}
            slidesPerView={1}
            spaceBetween={10}
          >
            {sectionLinks?.map((section) => (
              <SwiperSlide key={section.title}>
                <SlideWrapper>
                  <StyledH5>{section.title}</StyledH5>
                  <ContentWrapper>{section.content}</ContentWrapper>
                  <AuthorWrapper>
                    {!!section.image?.asset && (
                      <ImageWrapper>
                        <SanityImage2
                          sizes="64px"
                          src={section.image.asset._ref}
                          alt={section.image.alt ?? "Testimonial image"}
                        />
                      </ImageWrapper>
                    )}
                    <AuthorInfo>
                      <AuthorName>{section.author}</AuthorName>
                      <Button to={section.sectionLink.url} {...section}>
                        <LearnMore>{section.sectionLink.title}</LearnMore>
                      </Button>
                    </AuthorInfo>
                  </AuthorWrapper>
                </SlideWrapper>
              </SwiperSlide>
            ))}
          </Swiper>
        </Wrapper>
      </Container>
    );
  },
);

export default TestimonialSlider;
